export const formatCompleteDate = date => {
    const fecha = new Date(date);
    return fecha.toLocaleString('es-ES');
}